module.exports = __webpack_public_path__ + "img/logo.f1f62bc6.png";